import { useTranslation } from "react-i18next";
import { MODAL_STEPS } from "../../../../constants/modal";
import {
  capitalizeFirstLetter,
  getErrorTitle,
  useIsMobile,
} from "../../../../utils";
import React, { useEffect, useRef } from "react";
import { findBrandByDomain } from "../../../../configs/configLoader";
import { uxHideConsentTitle } from "../../../../configs";
import { isFootwear } from "../../../../utils/categoryParams";
import ArrowIconNew from "../../../../assets/icons/ArrowIconNew";

import "./index.css";

interface StepTitleProps {
  step: any | null;
  titleTextTransform: string;
  titleStyles: any;
  outOfRange: boolean;
  MODAL_STEPS_TITLE: string[];
  handleGoBack: (currentStep: any | null) => void;
}

export const StepTitle = ({
  step,
  titleTextTransform,
  titleStyles,
  outOfRange,
  MODAL_STEPS_TITLE,
  handleGoBack,
}: StepTitleProps) => {
  const isMobile = useIsMobile();

  const titleRef = useRef<HTMLHeadingElement>(null);

  const { t } = useTranslation("components/intro");

  const brandDefined = findBrandByDomain();

  const isSRP = brandDefined?.name === "SRP";
  const isLacoste = brandDefined?.name === "Lacoste";
  const isVB = brandDefined?.name === "Victoria Beckham";
  const isVelour = brandDefined?.name === "Velour Garments";
  const isGivenchy = brandDefined?.name === "Givenchy";
  const isTDF = brandDefined?.name === "TDF";
  const isPXP = brandDefined?.name === "Project X Paris";

  const isGivenchyDesktop = isGivenchy && !isMobile;
  const isGivenchyMobile = isGivenchy && isMobile;

  const isFirstIntroScreen =
    step?.number === MODAL_STEPS.INTRO.number ||
    step?.number === MODAL_STEPS.GENDER.number ||
    step?.number === MODAL_STEPS.INTRO_MOBILE.number;

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [step?.number]);

  if (
    !step ||
    isVB ||
    (uxHideConsentTitle && step?.number === MODAL_STEPS.CONSENT.number) ||
    (step?.number === MODAL_STEPS.QR_CODE.number && !isTDF && !isGivenchy) ||
    (isMobile && isFootwear && isFirstIntroScreen) ||
    (isMobile && isVelour) ||
    (isTDF && step?.number === MODAL_STEPS.INTRO.number) ||
    (isTDF && step?.number === MODAL_STEPS.INTRO_MOBILE.number)
  ) {
    return null;
  }

  const getTitle = () => {
    const isErrorStep = step?.number === MODAL_STEPS.ERROR.number;

    if (isErrorStep) {
      const errorKey = getErrorTitle({ outOfRange });
      return t(errorKey).replace(/&nbsp;/g, "\u00A0");
    }

    if (titleTextTransform === "capitalize" && !isGivenchy) {
      return capitalizeFirstLetter(MODAL_STEPS_TITLE[step?.number]).replace(
        /&nbsp;/g,
        "\u00A0",
      );
    }

    return MODAL_STEPS_TITLE[step?.number].replace(/&nbsp;/g, "\u00A0");
  };

  const isShowArrowIcon =
    isTDF &&
    step?.number !== MODAL_STEPS.RESULT.number &&
    step?.number !== MODAL_STEPS.ERROR.number;

  const handleKeyDown = (e: any) => {
    e.stopPropagation();

    if (e.key === "Enter") {
      handleGoBack(step);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {isShowArrowIcon ? (
        <ArrowIconNew
          role="button"
          tabIndex={0}
          onKeyDown={handleKeyDown}
          onClick={() => handleGoBack(step)}
          style={{
            color: "black",
            width: "24px",
            height: "26px",
            transform: "rotate(180deg)",
            position: "relative",
            right: "5px",
            cursor: "pointer",
          }}
        />
      ) : null}
      <h2
        ref={titleRef}
        className={isPXP ? "h2-pxp" : ""}
        style={{
          textAlign:
            isLacoste && step?.number === MODAL_STEPS.RESULT.number
              ? "center"
              : titleStyles.textAlign,
          fontWeight: titleStyles.fontWeight,
          textTransform: (titleTextTransform === "capitalize"
            ? "none"
            : titleTextTransform) as React.CSSProperties["textTransform"],
          color: isFootwear ? "#2E2E2E" : titleStyles.color,
          fontSize: titleStyles.fontSize,
          minHeight: isTDF ? "28px" : "25px",
          marginTop: isGivenchyMobile
            ? "30px"
            : isGivenchyDesktop ||
                (isMobile &&
                  isSRP &&
                  step?.number === MODAL_STEPS.RESULT.number)
              ? 0
              : "15px",
          marginBottom: !isMobile ? 0 : "10px",
          letterSpacing: titleStyles.letterSpacing,
          position: "relative",
          right: isTDF && isShowArrowIcon ? "5px" : "",
        }}
      >
        {getTitle()}
      </h2>
    </div>
  );
};

export default StepTitle;
